<template>
   <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div v-if="isRestrictions(privilege)" class="dialog-title">
                    <div v-if="editUserList.length == 0" v-t="{ path: 'message.title_add_appRestriction', args: { privilegeName: getPrivilegeDisplayName(privilege) } }"></div>
                    <div v-else v-t="{ path: 'message.title_edit_appRestriction', args: { privilegeName: getPrivilegeDisplayName(privilege) } }"></div>
                </div>
                <div v-else class="dialog-title">
                    <div v-if="editUserList.length == 0" v-t="{ path: 'message.title_add_privilege', args: { privilegeName: getPrivilegeDisplayName(privilege) } }"></div>
                    <div v-else v-t="{ path: 'message.title_edit_privilege', args: { privilegeName: getPrivilegeDisplayName(privilege) } }"></div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <UserSelection
                        :appData="appData"
                        :title="selectedTitle"
                        :selectedUsers="editUserList"
                        :selectionType="selectionType"
                        :showAdminUser="showAdminUser"
                        @changeSelectedUser="handleChangeSelectedUser()"
                        ref="UserSelection">
                    </UserSelection>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.disableSave" @click="saveUpdatedInfo" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';
import UserSelection from "./UserSelection.vue"

export default {
    data() {
      return {
          selectedTitle: null,
          selectionType: 0,
          showAdminUser: false,
          disableSave: true
      };
    },
    methods: {
        handleChangeSelectedUser() {
            this.disableSave = false;
        },
        saveUpdatedInfo() {
            this.$emit('save' , { removeTagList: this.$refs.UserSelection.removeTagList , addTagList: this.$refs.UserSelection.addTagList } );
        },
        getPrivilegeDisplayName(privilege) {
            return commonUtil.getPrivilegeDisplayName(this.$i18n, privilege);
        },
        isRestrictions(privilege) {
            switch(privilege) {
                case constants.RESTRICTION_LOGOUT:
                case constants.RESTRICTION_PEER_TO_PEER:
                case constants.RESTRICTION_MAP_TAB:
                case constants.RESTRICTION_CHAT_TAB:
                case constants.RESTRICTION_CHAT_SEND:
                case constants.RESTRICTION_SAVE_CONTENTS:
                case constants.RESTRICTION_MODIFY_NAME:
                    return true;
                case constants.PRIVILEGE_TENANT_ADMIN:
                case constants.PRIVILEGE_ALERT:
                    return false;
            }
        }
    },
    components: {
        UserSelection
    },
    created: function() {
        this.disableSave = true;
        switch(this.privilege) {
            case constants.RESTRICTION_LOGOUT:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_restrict_user").replace("{privilegeName}",commonUtil.getMessageText(this.$i18n,"item_logout"));
                this.selectionType = constants.USER_SELECTION_FORCE_RESTRICTIONS;
                break;
            case constants.RESTRICTION_PEER_TO_PEER:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_restrict_user").replace("{privilegeName}",commonUtil.getMessageText(this.$i18n,"item_individual_talk"));
                this.selectionType = constants.USER_SELECTION_FORCE_RESTRICTIONS;
                break;
            case constants.RESTRICTION_MAP_TAB:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_restrict_user").replace("{privilegeName}",commonUtil.getMessageText(this.$i18n,"item_map_tab"));
                this.selectionType = constants.USER_SELECTION_FORCE_RESTRICTIONS;
                break;
            case constants.RESTRICTION_CHAT_TAB:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_restrict_user").replace("{privilegeName}",commonUtil.getMessageText(this.$i18n,"item_chat_tab"));
                this.selectionType = constants.USER_SELECTION_FORCE_RESTRICTIONS;
                break;
            case constants.RESTRICTION_CHAT_SEND:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_restrict_user").replace("{privilegeName}",commonUtil.getMessageText(this.$i18n,"item_chat_send"));
                this.selectionType = constants.USER_SELECTION_FORCE_RESTRICTIONS;
                break;
            case constants.RESTRICTION_SAVE_CONTENTS:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_restrict_user").replace("{privilegeName}",commonUtil.getMessageText(this.$i18n,"item_save_contents"));
                this.selectionType = constants.USER_SELECTION_FORCE_RESTRICTIONS;
                break;
            case constants.RESTRICTION_MODIFY_NAME:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_restrict_user").replace("{privilegeName}",commonUtil.getMessageText(this.$i18n,"item_modify_name"));
                this.selectionType = constants.USER_SELECTION_FORCE_RESTRICTIONS;
                break;
            case constants.PRIVILEGE_TENANT_ADMIN:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_permit_user").replace("{privilegeName}",commonUtil.getMessageText(this.$i18n,"item_tenant_management"));
                this.selectionType = constants.USER_SELECTION_TENANT_ADMIN;
                this.showAdminUser = true;
                break;
            case constants.PRIVILEGE_ALERT:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_permit_user").replace("{privilegeName}",commonUtil.getMessageText(this.$i18n,"item_send_alert"));
                this.selectionType = constants.USER_SELECTION_FORCE_ACTIVATE;
                break;
        }
    },
    props: [ 'appData', 'privilege' , 'editUserList']
}
</script>


<style scoped>
.dialog-modal-mask {
    position: fixed;
    z-index: 1999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.dialog-input-field {
    height: 60px;
}

.title-box-command-normal {
    font-size: 14px;
    color: #5171cb;
}

.default-message {
    position: relative;
    top: 10%;
    opacity: 0.6;
    text-align: center;
    vertical-align: middle;
}

button.transparent-button {
    border-style: none;
    color: #333B48;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
}

.searched-user {
  padding: 10px;
  padding-left: 29px;
  cursor: pointer;
}
.searched-user:hover {
  background-color: #ecf1fa;
}

.input-with-select >>> .el-input-group__prepend {
    background-color: #fff;
}

.input-with-select >>> .el-select .el-input {
    font-size: 14px;
    width: 120px;
}

.el-input-group {
    width: 650px;
    padding-left: 20px;
    padding-bottom: 0px;
}

.el-select-dropdown__item.selected {
    color: #000000;
}

.el-select-dropdown__item {
    font-size: 14px;
}

.input-with-select >>> .el-button {
    width: 40px;
    padding: 0;
}
</style>
